import React from 'react';
import { NewHeroSection } from './components/NewHeroSection';
import { SocialProofSection } from './components/SocialProofSection';
import { NewProblemSection } from './components/NewProblemSection';
import { NewSolutionSection } from './components/NewSolutionSection';
import { FeaturesSection } from './components/FeaturesSection';
import { ModulesSection } from './components/ModulesSection';
import { UrgencyCTABlock } from './components/UrgencyCTABlock';
import { NewBonusSection } from './components/NewBonusSection';
import { NewPricingSection } from './components/NewPricingSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FAQSection } from './components/FAQSection';
import { FinalCTASection } from './components/FinalCTASection';
export function App() {
  return <div className="min-h-screen w-full bg-white" data-id="element-0">
      <main data-id="element-1">
        <NewHeroSection data-id="element-2" />
        <SocialProofSection data-id="element-3" />
        <NewProblemSection data-id="element-4" />
        <NewSolutionSection data-id="element-5" />
        <FeaturesSection data-id="element-6" />
        <ModulesSection data-id="element-7" />

        {/* CTA urgencia después de módulos */}
        <UrgencyCTABlock headline="Accedé ahora antes de que se agoten los cupos" subtext="12 módulos completos + 14 bonos en un solo pago" buttonText="Quiero el curso completo" offsetMinutes={97} data-id="element-8" />

        <NewBonusSection data-id="element-9" />

        {/* CTA urgencia después de bonos */}
        <UrgencyCTABlock headline="Llevate los 14 bonos antes de que cierren los cupos" subtext="Todo incluido — curso + bonos + soporte 24/7" buttonText="Acceder ahora — últimos 3 cupos" offsetMinutes={97} data-id="element-10" />

        <NewPricingSection data-id="element-11" />
        <GuaranteeSection data-id="element-12" />
        <FAQSection data-id="element-13" />
        <FinalCTASection data-id="element-14" />

        {/* Footer */}
        <footer className="bg-[#F8F8FA] py-12 px-4 border-t border-gray-200" data-id="element-15">
          <div className="container mx-auto max-w-4xl text-center" data-id="element-16">
            <p className="text-[#6B6B6B] text-sm md:text-base mb-2" data-id="element-17">
              © 2026 Todos los derechos reservados
            </p>
            <p className="text-gray-500 text-xs md:text-sm" data-id="element-18">
              Pago seguro • Soporte 24/7 • Garantía 72hs
            </p>
          </div>
        </footer>
      </main>
    </div>;
}